namespace TabAurous.Finance {
    export interface ContraDetailForm {
        TransDetailId: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        Mode: PaymentModesEditor;
        Amount: Serenity.DecimalEditor;
        ExchangeRateId: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
    }

    export class ContraDetailForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.ContraDetail';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ContraDetailForm.init)  {
                ContraDetailForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = PaymentModesEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(ContraDetailForm, [
                    'TransDetailId', w0,
                    'LedgerId', w1,
                    'Mode', w2,
                    'Amount', w3,
                    'ExchangeRateId', w3,
                    'ChequeNo', w0,
                    'ChequeDate', w4
                ]);
            }
        }
    }
}
